export default function OfferDetailsCard({ offerDetails, packageSummary, joiningDateLabel }) {
  if (!offerDetails) return null;
  const pkg =
    packageSummary ||
    `${offerDetails.currency || ''} ${offerDetails.package || '—'}`.trim();

  return (
    <div className="border border-purple-200 bg-purple-50/50 p-3 text-sm space-y-2">
      <p className="font-medium text-[hsl(var(--ds-fg))]">Offer terms</p>
      <dl className="grid grid-cols-[minmax(7rem,auto)_1fr] gap-x-3 gap-y-1.5 text-xs">
        <dt className="text-[hsl(var(--ds-muted-fg))]">Designation</dt>
        <dd className="font-medium">{offerDetails.designation || '—'}</dd>
        {offerDetails.department && (
          <>
            <dt className="text-[hsl(var(--ds-muted-fg))]">Department</dt>
            <dd>{offerDetails.department}</dd>
          </>
        )}
        <dt className="text-[hsl(var(--ds-muted-fg))]">Package</dt>
        <dd>{pkg}</dd>
        <dt className="text-[hsl(var(--ds-muted-fg))]">Joining date</dt>
        <dd>{joiningDateLabel || offerDetails.expectedJoiningDate || '—'}</dd>
        {offerDetails.workLocation && (
          <>
            <dt className="text-[hsl(var(--ds-muted-fg))]">Location</dt>
            <dd>{offerDetails.workLocation}</dd>
          </>
        )}
        {offerDetails.employmentType && (
          <>
            <dt className="text-[hsl(var(--ds-muted-fg))]">Employment</dt>
            <dd className="capitalize">{offerDetails.employmentType}</dd>
          </>
        )}
        {offerDetails.probationPeriod && (
          <>
            <dt className="text-[hsl(var(--ds-muted-fg))]">Probation</dt>
            <dd>{offerDetails.probationPeriod}</dd>
          </>
        )}
        {offerDetails.benefits && (
          <>
            <dt className="text-[hsl(var(--ds-muted-fg))]">Benefits</dt>
            <dd className="whitespace-pre-wrap">{offerDetails.benefits}</dd>
          </>
        )}
        {offerDetails.additionalNotes && (
          <>
            <dt className="text-[hsl(var(--ds-muted-fg))]">Notes</dt>
            <dd className="whitespace-pre-wrap">{offerDetails.additionalNotes}</dd>
          </>
        )}
      </dl>
    </div>
  );
}
